import * as React from 'react';

import Logo from '@/components/Logo';
import { useScale } from '@/hooks/useScale';

const BASE_HEIGHT = 38;

const TopbarLogo: React.FC = () => {
  const scale = useScale();
  const height = BASE_HEIGHT * scale;

  return <Logo height={height} scaleProportionally />;
};

export default TopbarLogo;
